import { render, staticRenderFns } from "./MemberCardList.vue?vue&type=template&id=6a47b6d8&scoped=true"
import script from "./MemberCardList.vue?vue&type=script&lang=js"
export * from "./MemberCardList.vue?vue&type=script&lang=js"
import style0 from "./MemberCardList.vue?vue&type=style&index=0&id=6a47b6d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a47b6d8",
  null
  
)

export default component.exports